import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-search-exact" }
const _hoisted_2 = ["checked"]

import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-search-exact',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();



const emit = __emit;

function update(event: Event) {
  const input = event.target as HTMLInputElement;

  emit("update:modelValue", input.checked);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: __props.modelValue,
      onChange: update
    }, null, 40, _hoisted_2),
    _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.search_exact")), 1)
  ]))
}
}

})